import { CollectionCard } from "@components/Cards/CollectionCard"
import { Box } from "@components/Layout"
import { CbSingleCollectionCollections } from "@lib/kontent/models/CbSingleCollectionCollections"
import React from "react"

interface Props {
  items: CbSingleCollectionCollections[]
}

const CollectionGrid: React.FC<Props> = ({ items }) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={["100%", "repeat(3, 1fr)"]}
      gridColumnGap={["1rem", "1.5rem"]}
      gridRowGap={["1rem", "1.5rem"]}
    >
      {items.map((collection) => (
        <CollectionCard key={collection.link_url.value} {...collection} />
      ))}
    </Box>
  )
}

export default CollectionGrid
